import * as ko from "knockout";
import {IIsSystemPropertyMutable, ISystemMutable, ISystemRoleMutable} from "./index";
import {ErrorObject} from "../../error/ErrorObject";
import {MAX_DESCRIPTION_LENGTH} from "../../constants";
import {isNullOrUndefinedOrEmptyString, validateEmail} from "../../util/misc";
import {ISystem} from "../../index";
import {global} from "../../appContext";

export namespace nsSystemAccess {
    export function createSystemMutable(): ISystemMutable {
        const ret: ISystemMutable = {
            errName: new ErrorObject({name: 'name'}),
            errDescription: new ErrorObject({name: 'description'}),
            errSystemOwner: new ErrorObject({name: 'systemOwner'}),
            isSystemMegaEadm: false,

            availableto: ko.observable(null),
            description: ko.observable(''),
            managedby: ko.observable(null),
            multiplerolesamecompany: ko.observable(true),
            multiplerolesamedepartment: ko.observable(true),
            name: ko.observable(''),
            prioritybasedroles: ko.observable(false),
            purgemanualdepartmentpermissions: ko.observable(false),
            roles: ko.observableArray<ISystemRoleMutable>([]),
            systemowner: ko.observable(''),
        }

        ret.errName.addValidator({
            fn: () => !!ret.name(),
            message: 'invalid name',
        })

        ret.errDescription.addValidator({
            fn: () => ret.description().length <= MAX_DESCRIPTION_LENGTH,
            message: 'invalid length',
        })

        ret.errSystemOwner.addValidator({
            fn: () => validateEmail(ret.systemowner()),
            message: 'invalid email',
            prerequisite: () => !isNullOrUndefinedOrEmptyString(ret.systemowner()),
        })

        return ret
    }

    export function getIsPropertyMutable(): IIsSystemPropertyMutable {
        return {
            availableto_id: true,
            companyid: true,
            description: true,
            id: true,
            isreadonly: false,
            managedby_id: true,
            multiplerolesamecompany: true,
            multiplerolesamedepartment: true,
            name: true,
            prioritybasedroles: true,
            purgemanualdepartmentpermissions: true,
            roles: true,
            systemowner: true,
        } as const
    }

    export function systemMutable2Static(md: ISystemMutable): ISystem {
        const ret: ISystem = {
            availableto_id: md.availableto()?.id ?? 0,
            companyid: global.login.selectedOrganizationId() ?? '',
            description: md.description(),
            id: 0,
            isreadonly: false,
            managedby_id: md.managedby()?.id ?? 0,
            multiplerolesamecompany: md.multiplerolesamecompany(),
            multiplerolesamedepartment: md.multiplerolesamedepartment(),
            name: md.name(),
            prioritybasedroles: md.prioritybasedroles(),
            purgemanualdepartmentpermissions: md.purgemanualdepartmentpermissions(),
            roles: [],
            systemowner: md.systemowner(),
        }
        return ret
    }
}